import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { CanEditFormFields } from '@occc-app/App/CanEditFormFieldsContext';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { getLoyaltyEventUpdatePageHeaderLinks } from '@occc-app/routes/LoyaltyEvent/utils';
import { LoyaltyEventConfigureFormContainer } from '../components/LoyaltyEventConfigureForm/LoyaltyEventConfigureFormContainer';
import { messages } from '../messages';

export const LoyaltyEventUpdatePageContainer = () => {
  const { offerId = '' } = useParams<{ id: string; offerId: string }>();
  const isUserPermittedToEditLoyaltyEvent = useIsUserPermittedTo(Feature.LOYALTY_EVENT_EDIT);

  const loyaltyEventPageLinkLabel = isUserPermittedToEditLoyaltyEvent
    ? 'Configure Loyalty Event'
    : 'Loyalty Event Configurations';

  const breadcrumbLinks = (offerName: string) => {
    return getLoyaltyEventUpdatePageHeaderLinks(
      offerName || 'Loading',
      offerId,
      loyaltyEventPageLinkLabel,
    );
  };

  return (
    <CanEditFormFields isEditable={isUserPermittedToEditLoyaltyEvent}>
      <OfferUpdatePageContainer
        offerId={offerId}
        getBreadcrumbLinks={breadcrumbLinks}
        pageTitle={loyaltyEventPageLinkLabel}
        subtitle={messages.subtitle}
        offerType={OfferType.LoyaltyEvent}
        ConfigureFormContainer={LoyaltyEventConfigureFormContainer}
        showSurgeonGeneralsWarning={false}
      />
    </CanEditFormFields>
  );
};
